declare namespace $ {

	export class $mol_icon_storefront extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=storefront.view.tree.d.ts.map